import { render, staticRenderFns } from "./gCol.vue?vue&type=template&id=0edf05d6&scoped=true&"
import script from "./gCol.vue?vue&type=script&lang=js&"
export * from "./gCol.vue?vue&type=script&lang=js&"
import style0 from "./gCol.vue?vue&type=style&index=0&id=0edf05d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf05d6",
  null
  
)

component.options.__file = "gCol.vue"
export default component.exports